import { useRouter } from "next/router";
import { useContext } from "react";
import { getAuthenticatedUserClient } from "../../../utils/getAuthenticatedUser";
import { withGlobalPageSpinner } from "../../../components/GlobalPageSpinner";
import { CookieContext } from "../../../context/cookieContext";
import { V3ReferralPageLayout } from "../../../pagelayouts/settings/referral";
import IntercomTracker from "../../../tracking/Intercom";
import { ClientOnly } from "../../../components/ClientOnly";

const RefferalPage = () => {
    const router = useRouter();
    const token = useContext(CookieContext) as string;

    const { authenticatedUser } = getAuthenticatedUserClient(token, router);

    new IntercomTracker(authenticatedUser.data);

    return (
        <ClientOnly>
            {withGlobalPageSpinner(authenticatedUser.isLoading || !authenticatedUser.data, <V3ReferralPageLayout user={authenticatedUser.data} />)}
        </ClientOnly>
    );
};

export default RefferalPage;
